import type { Language } from '@offer-catalog/services/i18n'
import type { GalleryModel } from '@/components/ProductCard/types'
import { VpPrice, VpPriceAmount } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { CustomerReviews } from './CustomerReviews'
import { DataFallback } from './DataFallback'
import './model-basic-info.scss'

export function ModelBasicInfo({
  productModel,
  showPrice = true,
  showCustomerReview = true,
}: Readonly<{
  productModel: GalleryModel
  showPrice?: boolean
  showCustomerReview?: boolean
}>) {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language
  const superModelId = productModel.super_model.id.toString()
  const modelId = productModel.model.id.toString()

  return (
    <section
      className="model-card-basic-info"
      data-testid="model-card_basic-info"
    >
      <div className="sm-id" data-testid={`sm-id_${superModelId}`}>
        <span className="sr-only">{superModelId.split('').join(' ')}</span>
        <span aria-hidden="true">{superModelId}</span>
      </div>
      <h2 className="sm-label" data-testid={`sm-label_${productModel.super_model.id}`}>
        {productModel.super_model.labels[currentLanguage]}
      </h2>
      <div
        className="model-id"
        data-testid={`model-id_${modelId}`}
      >
        <span className="sr-only">{modelId.split('').join(' ')}</span>
        <span aria-hidden="true">{modelId}</span>
      </div>
      <div
        className="model-label"
        data-testid={`model-label_${productModel.model.id}`}
      >
        {productModel.model.labels[currentLanguage]}
      </div>
      {showPrice && (
        <div className="basic-info-price">
          <DataFallback
            value={productModel.price}
            fallbackKey="products-page.product-card.no-price"
            isEmpty={price => price.amount == null || !price.currency}
          >
            {price => (
              <VpPrice>
                <VpPriceAmount>
                  {price.amount}
                  {' '}
                  {price.currency}
                </VpPriceAmount>
              </VpPrice>
            )}
          </DataFallback>
        </div>
      )}
      {showCustomerReview && productModel.review && <CustomerReviews review={productModel.review} />}
    </section>
  )
}
